import styled from 'styled-components'

export const CardTitle = styled.span`
	display: block;
	font-size: 18px;
	font-weight: 600;
	line-height: 24px;
	margin-top: 9px;
`
